export * as Slider from "@rn-primitives/slider";
